import * as amplitude from '@amplitude/analytics-browser'

class Analytics {
  static setUser(username) {
    const identifyEvent = new amplitude.Identify()
    identifyEvent.set('username', username)
    amplitude.identify(identifyEvent)
  }

  static track(eventName, properties) {
    amplitude.track({
      event_type: eventName,
      event_properties: {
        path: window.location.pathname,
        url: window.location.href,
        ...properties,
      },
    })
  }
}

export default Analytics
